module.exports = __webpack_public_path__ + "img/tsd-green.7f61c6ab.svg";